export const API_VERSION = {
  V1: '/v1',
} as const;
